import { TaskContentBottom } from "../components/task-content"
import { TaskCompareScheduleDetails } from "./task-compare-schedule-details"

TaskContentBottom.plug(<TaskCompareScheduleDetails if={(c) => !!c.isSimilarResults} />)
